import { Component, ElementRef, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { Content, NavController, NavParams } from 'ionic-angular';
import { Subject } from 'rxjs';
import { AlphabetizedCollection } from '../../models/alphabetized-collection';
import { Entry } from '../../models/entry';
import { DirectoryService } from '../../providers/directory-service';
import { FirebaseAnalytics } from '@ionic-native/firebase-analytics';
import { DesktopService } from "../../providers/desktop-service";

@Component({
  selector: 'page-bookmarks',
  templateUrl: 'bookmarks.html'
})
export class BookmarksPage {

    @ViewChild('alphaBar') private alphaBarRef: ElementRef;
    @ViewChildren('sectionLetter') private sectionHeaderRefs: QueryList<ElementRef>;
    @ViewChild('content') private ionContent: Content;

    public alphaBar: HTMLElement;
    public alphaScroll = new Subject<string>();

    public bookmarks: AlphabetizedCollection<Entry>;

    constructor(
        public analytics: FirebaseAnalytics,
        public directoryService: DirectoryService,
        public navCtrl: NavController,
        public navParams: NavParams,
        private desktopService: DesktopService,
    ) {
        let bookmarks = this.navParams.get('bookmarks');

        this.bookmarks = new AlphabetizedCollection(bookmarks, entry => {
            return entry.title.charAt(0).toUpperCase();
        }, (a, b) => {
            const title_a = AlphabetizedCollection.removeSpecialCharsAndLowercase(a.title);
            const title_b = AlphabetizedCollection.removeSpecialCharsAndLowercase(b.title);

            if (title_a < title_b) return -1;
            if (title_a > title_b) return 1;
            return 0;
        });
    }

    public ionViewDidEnter() {
        this.analytics.setCurrentScreen('Bookmarks');
    }

    public ngAfterViewInit() {
        this.alphaBar = this.alphaBarRef.nativeElement;

        let touches: number = 0;
        let letter = null;

        this.alphaBar.addEventListener('touchstart', event => {
            touches++;
        });

        this.alphaBar.addEventListener('touchend', event => {
            letter = null;
            touches--;
        });

        this.alphaBar.addEventListener('touchmove', event => {
            if (touches <= 0) return;

            let touch = event.touches.item(0);
            let children = this.alphaBar.children;
            let y = touch.clientY;

            for (let i = 0; i < children.length; i++) {
                let child = children.item(i);
                let bounds = child.getBoundingClientRect();

                if (y < bounds.top) continue;
                if (y > bounds.bottom) continue;

                let data = child.getAttribute('data');

                if (letter != data) {
                    letter = data;
                    this.alphaScroll.next(letter);
                }
            }
        });

        this.alphaScroll.subscribe(letter => {
            this.sectionHeaderRefs.forEach(elementRef => {
                let element: HTMLElement = elementRef.nativeElement;
                let content = element.innerText;

                if (letter.toUpperCase() == content.toUpperCase()) {
                    this.ionContent.scrollTo(0, element.offsetTop);
                }
            })
        })
    }

    public getParentsForEntry(entry: Entry) {
        let parents = [];

        for (let parent of entry.parents) {
            parents.push(parent.title);
        }

        return parents.length > 0 ? parents.reverse() : null;
    }

    public showEntry(entry: Entry) {
        this.directoryService.showEntry(entry);
    }

}




// WEBPACK FOOTER //
// ./src/pages/bookmarks/bookmarks.ts